import formatter from "../../../../../../utils/formatter";

export const WarningContent = {
  single: "Are you sure you want to cancel this grant? Do you want to continue?",
  spawns:
    "Are you sure you want to cancel this Grant? Selecting Yes will cancel the exchange schedule and delete all optional information entered for all the upcoming spawns.",
  recurring:
    "Are you sure you want to cancel this recurring grant schedule? Selecting Yes will cancel the schedule and delete all optional information entered for all the upcoming payments. The organization name will remain under ‘Recently Supported Charities’ for future grant recommendations."
};

// Sorter Functions
export function compareByAlph(a, b) {  
  if (a > b) {
    return -1;
  }
  if (a < b) {
    return 1;
  }
  return 0;
}

//Amount Render
export const renderAmount = text => {
  if (text !== "--") {
    return formatter({
      value: text,
      fieldSuffix: "Dollars"
    });
  } else {
    return text;
  }
};

